import Services from '@/services/index';
import VT from '@/store/types';
import { Backend } from '@/_axios';

export default {
  [VT.LOGIN]: ({ commit }, loginData) => {
    return new Promise((resolve, reject) => {
      Services.auth.login(loginData).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        Backend.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        commit(VT.SET_AUTH_INFO, { ...data, remember: loginData.remember });
        if (data.refresh_token) {
          commit(VT.SET_REFRESH_TOKEN, data.refresh_token);
        }
        resolve();
      }, () => {
        reject();
      });
    });
  },
  [VT.LOAD_USER_INFO]: ({ commit }) => {
    Services.auth.user().then(({ data }) => {
      commit(VT.SET_AUTH_INFO, data);
    }).catch((errResponse) => {
      console.log(errResponse);
    });
  },
  [VT.LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      commit(VT.SET_AUTH_TOKEN, null);
      commit(VT.SET_REFRESH_TOKEN, null);
      resolve();
    });
  },
  [VT.UPDATE_AUTH_TOKEN]: ({ commit }, token) => {
    return new Promise((resolve) => {
      commit(VT.SET_AUTH_TOKEN, token);
      Backend.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      resolve();
    });
  },

  [VT.REFRESH_AUTH_TOKEN]: ({ commit, getters, state }) => {
    return new Promise((resolve, reject) => {
      if (!getters['refreshTokenValid'](10)) {
        reject();
      }

      Services.auth.refresh(state.refreshToken, state.remember).then(({ data }) => {
        commit(VT.SET_AUTH_TOKEN, data.access_token);
        commit(VT.SET_REFRESH_TOKEN, data.refresh_token);
        Backend.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        resolve(data.access_token);
      });
    });
  },
};
